import { defineMessages } from 'react-intl';

export default defineMessages({
	discountUpsell: {
		id: 'app.components.NavControls.discountUpsell',
		defaultMessage: 'Get 40% off',
		description: 'upsell button for today only discount',
	},
});
